import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { SoundComponent } from "./components/SoundComponent";
import { NavigationComponent } from "./components/NavigationComponent";
import { ReadComponent } from "./components/ReadComponent";
import { PcComponent } from "./components/PcComponent";
import { KeyComponent } from "./components/KeyComponent";
import { WeldingMinigameComponent } from "./components/WeldingMinigameComponent";
import { CutsceneComponent } from "./components/CutsceneComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { GameOverComponent } from "./components/GameOverComponent";
import { SeaBeastBattleComponent } from "./components/SeaBeastFightComponent";
import { AchievementComponent } from "./components/AchievementComponent";
import { EndCreditsComponent } from "./components/EndCreditsComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-sound", SoundComponent);
window.customElements.define("navigation-arrows", NavigationComponent);
window.customElements.define("game-readpanel", ReadComponent);
window.customElements.define("game-pc", PcComponent);
window.customElements.define("game-key", KeyComponent);
window.customElements.define("welding-game", WeldingMinigameComponent);
window.customElements.define("cut-scene", CutsceneComponent);
window.customElements.define("game-achievement", AchievementComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-over", GameOverComponent);
window.customElements.define("sea-beast-battle", SeaBeastBattleComponent);
window.customElements.define("end-credits", EndCreditsComponent);
